module.exports = __webpack_public_path__ + "img/y_p3_y3.5d5e7509.png";